<template>
  <router-view></router-view>
  <NativeNotice />
  <NativeLoading />
</template>

<script setup lang="ts">
import { onMounted } from "vue";

import { useDefaultInfoStore } from "@/stores/defaultInfo";
import NativeNotice from "@/components/NativeUI/NativeNotice.vue";
import NativeLoading from "@/components/NativeUI/NativeLoading.vue";
const defaultInfoStore = useDefaultInfoStore();

onMounted(async () => {
  await Promise.all([defaultInfoStore.fetchDefaultInfo()]);
});
</script>

<style>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: system-ui, Avenir, Helvetica, Arial, sans-serif;
  color: #333;
  background-color: #f8f9fa;
}
</style>
